import React from 'react'
import { Route } from 'react-router-dom'
import { Switch } from './components/RouteSwitch'
import { LoadingPage } from './pages/_loading'
import { Overview } from './pages/Overview'
import { Category } from './pages/Category'
import { Item } from './pages/Item'

export const Routes: React.FC = () => (
  <React.Suspense fallback={<LoadingPage />}>
    <Switch>
      <Route exact={true} path="/" component={Overview} />
      <Route exact={true} path="/:category" component={Category} />
      <Route exact={true} path="/:category/:item" component={Item} />
    </Switch>
  </React.Suspense>
)
